import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInformationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 5,
			r: 5,
			fill: "#85A0AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.75 4.375H5V6.875H3.75H6.25",
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 2.5V3.4375",
			stroke: "white"
		})
	]
});
export default SvgInformationIcon;
